import script from "./Extensions.vue?vue&type=script&lang=js"
export * from "./Extensions.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__